{
  "ShortlistThemePreview": {
    "label": "候选名单预览",
    "sampleTitle": "夏季活动",
    "sampleDescription": "我们为夏季拍摄挑选的人选。为你想预订的人投票。",
    "sampleChipAccent": "已入选",
    "sampleChipTint": "巴黎",
    "sampleSecondaryAction": "筛选"
  },
  "public.detail": {
    "search.placeholder": "搜索名单",
    "hero.shortlistBy": "入围名单 {{name}}",
    "empty.title": "无人入围",
    "empty.description": "通过选择要呈现给利益相关者的资源来构建您的候选列表",
    "filters.label": "筛选",
    "item.emptyValue": "无",
    "passwordProtection": {
      "enterPassword": "输入密码以查看候选名单",
      "placeholder": "输入密码",
      "viewShortlist": "查看候选名单"
    },
    "error": {
      "title": "搜索候选名单时出错"
    }
  },
  "GridViewItemGallery": {
    "editGallery": "编辑图库",
    "emptyGalleryTitle": "空图库",
    "emptyGalleryDescription": "为此资源添加媒体",
    "addMedia": "添加媒体"
  },
  "ShortlistVotes": {
    "upvote": "赞成",
    "downvote": "反对",
    "saveFailed": "无法保存您的投票。请重试。"
  },
  "GenericSearchFilterItem": {
    "filters": {
      "belongsToMe": "属于我",
      "createdAt": "创建于 {{date}} 之后",
      "publishedOnly": "仅已发布",
      "draftOnly": "仅草稿",
      "archived": "显示已归档",
      "between": "介于 {{startDate}} - {{endDate}} 之间",
      "tags": {
        "and": " 和 ",
        "more": " 更多",
        "any": "任意标签: {{tag}}",
        "match": "匹配标签: {{tags}}"
      }
    }
  },
  "ShortlistMediaSidebarPage": {
    "draft": "草稿",
    "votingDisabled": "候选名单未公布时禁止投票",
    "commentingDisabled": "候选名单未公布时禁止评论",
    "votingAndCommentingDisabled": "未发布时禁用投票和评论"
  },
  "MediaSidebar": {
    "Header": {
      "shortlistedCount": "已入围 {{count}} / {{totalBlocks}}",
      "previous": "上一位入围者",
      "next": "下一位入围者"
    },
    "CommentList": {
      "label": "评论",
      "guest": "访客",
      "noComments": "还没有评论",
      "startConversation": "来说说你对{{name}}的看法吧。",
      "startConversationNoName": "与团队分享你对此人的看法。",
      "commentsOff": "评论已关闭",
      "anonymous": "匿名用户"
    },
    "CommentInput": {
      "writeComment": "写评论",
      "addComment": "添加评论",
      "writeFirstComment": "写下第一条评论",
      "sendFailed": "无法发送您的评论。请重试。"
    },
    "GuestNameChangeForm": {
      "title": "访客反馈",
      "description": "在下方输入您的姓名以留下反馈",
      "placeholder": "您的姓名",
      "saveChanges": "保存更改"
    },
    "GuestInfo": {
      "youAre": "您是 {{name}}",
      "change": "更改"
    },
    "Details": {
      "noFields": "此候选名单没有可显示的字段",
      "loadFailed": "无法加载字段。"
    },
    "Tabs": {
      "label": "分区",
      "comments": "评论",
      "details": "详情"
    }
  },
  "SetGuestNameModal": {
    "title": "设置访客名称",
    "description": "在投票或评论入围者之前，您需要告诉入围者您的身份",
    "yourName": "您的姓名",
    "saveName": "保存名称",
    "successfullyCreated": "创建成功",
    "guestNameSet": "访客名称已设置"
  },
  "ShortlistCreateButton": {
    "create": "创建候选名单"
  },
  "ShortlistCreateDialog": {
    "title": "创建候选名单",
    "description": "为新的候选名单命名、添加描述和标签。",
    "titleLabel": "标题",
    "titlePlaceholder": "候选名单标题",
    "titleRequired": "请输入标题",
    "descriptionLabel": "描述",
    "descriptionPlaceholder": "客户会在标题下方看到",
    "tagsLabel": "标签",
    "create": "创建"
  },
  "CardFieldsDialog": {
    "title": "卡片字段",
    "description": "此候选名单上每张卡片显示哪些字段，对所有人（包括客户）生效。",
    "rateHint": "第一张费率卡",
    "noCatalog": "此工作区的资源类型没有可在卡片上显示的字段。",
    "onCards": "卡片上",
    "selectedCount": "已选择 {{count}} / {{total}}",
    "order": "卡片字段顺序",
    "cut": "卡片显示上方的字段 · 详情显示全部",
    "reorderHint": "拖动以重新排序。将字段拖到线上方即可在卡片上显示。",
    "empty": "还没有字段。请从资源字段中选择。",
    "preview": "预览",
    "previewOf": "{{name}} · 第 {{position, number}} 个，共 {{total, number}} 个",
    "previous": "上一位",
    "next": "下一位",
    "previewEmpty": "向候选名单添加人员即可预览卡片。",
    "previewHint": "空值显示为“—”，因此每张卡片的布局都相同。",
    "unnamed": "未命名",
    "cancel": "取消",
    "onSet": "片场",
    "teamSettings": "团队设置"
  },
  "ClientDefaultFilterDialog": {
    "title": "客户默认筛选",
    "description": "客户打开候选名单时会应用此筛选，并可自行清除。",
    "filters": "筛选"
  },
  "AvailabilityDialog": {
    "title": "可用性",
    "description": "卡片是否显示预订可用性以及检查哪些日期。",
    "show": {
      "label": "在卡片上显示可用性",
      "description": "打开候选名单的每个人都能看到，包括客户。"
    },
    "dates": {
      "label": "日期",
      "description": "这些日期内的所有预订都会计入，无论其状态如何。",
      "required": "请选择要检查的日期"
    },
    "preview": {
      "label": "卡片上显示",
      "range": "{{from}} – {{to}}",
      "available": "可用 {{range}}",
      "booked": "{{status}} {{range}}",
      "privacy": "客户只能看到预订状态，看不到制作名称。"
    }
  },
  "SharingDialog": {
    "title": "分享与访问",
    "description": "客户链接、谁可以打开、客户反馈和品牌。",
    "status": {
      "published": "已发布",
      "draft": "草稿"
    },
    "link": {
      "title": "链接",
      "hint": "客户在此打开候选名单。取消发布后再次发布，链接保持不变。",
      "copy": "复制",
      "draftHint": "发布后客户即可打开。",
      "missing": "此候选名单还没有链接。"
    },
    "access": {
      "title": "谁可以打开",
      "link": {
        "label": "任何拥有链接的人",
        "description": "无需密码"
      },
      "password": {
        "label": "链接和密码",
        "description": "客户输入密码后才能打开链接",
        "placeholder": "密码",
        "show": "显示",
        "hide": "隐藏",
        "generate": "生成",
        "required": "请输入密码，或允许任何拥有链接的人打开"
      }
    },
    "feedback": {
      "title": "客户反馈",
      "voting": {
        "label": "投票",
        "description": "对每个人点赞或点踩"
      },
      "comments": {
        "label": "评论",
        "description": "每个人下的讨论"
      },
      "shared": {
        "label": "共享反馈",
        "description": "客户可以看到彼此的投票和评论"
      },
      "notifications": {
        "label": "有新反馈时给我发邮件",
        "description": "有人投票或评论时"
      }
    },
    "footer": {
      "published": "已发布",
      "publishedOn": "发布于 {{day}}",
      "notPublished": "尚未发布"
    },
    "publish": "发布",
    "unpublish": "取消发布",
    "published": "已发布。客户现在可以打开链接。",
    "unpublished": "已取消发布。下次链接保持不变。"
  },
  "ShortlistBrandingRow": {
    "defaultName": "Atellio",
    "profileHint": "来自公开资料设置"
  },
  "ShareStatusButton": {
    "share": "分享",
    "published": "已发布",
    "access": {
      "password": "密码",
      "link": "任何拥有链接的人"
    },
    "copyLink": "复制链接"
  },
  "ShortlistPublicLink": {
    "copied": "链接已复制",
    "copyFailed": "无法复制链接。请在此处选中并自行复制："
  },
  "ShortlistSettingsDialog": {
    "save": "为所有人保存",
    "saved": "已为所有人保存",
    "unsavedChanges": "这些设置有未保存的更改",
    "everyoneSees": "所有人可见"
  },
  "BlockGalleryEditDialog": {
    "title": "编辑图库",
    "description": "{{name}} 在此候选名单上展示的图片，按顺序排列。第一张为封面。",
    "thisShortlistOnly": "仅限此候选名单",
    "everyoneSees": "为此候选名单上的所有人保存，包括客户。",
    "cancel": "取消",
    "save": "保存图库",
    "uploading_other": "正在上传 {{count}} 个…",
    "saved": "图库已保存",
    "profileAddFailed": "图库已保存，但新文件未能添加到 {{name}} 的资料图板。",
    "unsavedChanges": "此图库有未保存的更改。",
    "sources": "添加来源",
    "pinboard": "资料图板",
    "loadingPinboard": "正在加载资料图板",
    "pinboardCount": "资料图板 · {{count}}",
    "upload": "上传",
    "searchPins": "按标签搜索图钉",
    "pinboardHint": "点击或将图钉拖到图库中。它会被复制到那里，资料本身保持不变。",
    "noPins": "{{name}} 的资料还没有图钉。请上传图片或添加链接。",
    "noMatches": "没有标记为“{{query}}”的图钉。",
    "uploadFormats": "或拖到图库上 · JPG、PNG、WebP 或 MP4，每个不超过 50 MB",
    "orAddLink": "或通过链接添加",
    "linkHint": "YouTube、Vimeo 或图片地址",
    "alsoAddToProfile": "同时将新文件添加到 {{name}} 的资料图板",
    "inThisGallery": "此图库中",
    "startOver": "从资料重新开始",
    "reorderHint": "拖动以重新排序。第一张是卡片上的封面。",
    "reorderHintNewFiles": "新文件会添加到末尾。拖动以重新排序；第一张是卡片上的封面。",
    "new": "新",
    "empty": "还没有图片。可在面板中选择，或拖到此处。",
    "linkPreview": {
      "notAUrl": "这不是一个网址",
      "notAUrlHint": "请粘贴以 https:// 开头的链接。",
      "brokenPicture": "无法加载此图片",
      "brokenPictureHint": "请检查地址。有些网站不允许其他页面显示其图片。",
      "missingVideo": "无法显示此视频",
      "missingVideoHint": "视频可能是私密的、已被删除，或链接不完整。",
      "unsupported": "此链接不是图片或视频",
      "unsupportedHint": "请添加 YouTube 或 Vimeo 视频，或图片地址。"
    },
    "dropTitle": "将图片或视频拖到此处",
    "chooseFiles": "选择文件",
    "addPictures": "添加图片",
    "picture": "张图片",
    "pictures": "张图片",
    "pin": "个图钉",
    "pins": "个图钉",
    "addSelected_other": "将 {{count}} 个图钉加入图库",
    "removeSelected_other": "从图库移除 {{count}} 项"
  },
  "BlockNote": {
    "label": "备注",
    "placeholder": "写一点关于{{name}}的内容",
    "placeholderUnnamed": "写一条备注"
  },
  "ShortlistCard": {
    "noNote": "无备注",
    "available": "可用",
    "booked_other": "{{count}} 个预订",
    "openGallery": "打开图库，第 {{index}} 张，共 {{count}} 张",
    "openGalleryPictures_other": "打开图库：{{count}} 张图片",
    "previousPicture": "上一张",
    "nextPicture": "下一张",
    "noPictures": "暂无图片",
    "editGallery": "编辑图库",
    "addPictures": "添加图片",
    "pictureUnavailable": "无法显示此图片",
    "morePictures_other": "还有 {{count}} 张图片"
  },
  "ShortlistBoardPage": {
    "closeDetails": "关闭详情",
    "shortlists": "候选名单",
    "resourceDetails": "资源详情",
    "belongsElsewhere": "此候选名单属于其他工作区或团队",
    "belongsElsewhereHint": "请从其所属工作区或团队的候选名单中打开。",
    "backToShortlists": "返回候选名单",
    "draft": "草稿",
    "published": "已发布",
    "saveFailed": "无法保存更改。"
  },
  "ShortlistBoardHeaderActions": {
    "mode": "模式",
    "edit": "编辑",
    "preview": "预览",
    "togglePreview": "切换预览",
    "feedback": "反馈 · {{count}}",
    "more": "更多操作",
    "sharingAndAccess": "共享与访问"
  },
  "ShortlistBoardBatchActions": {
    "person": "人",
    "people": "人",
    "remove_other": "从候选名单移除 {{count}} 人",
    "removeFailed": "无法从候选名单移除,请重试。"
  },
  "ShortlistAddResources": {
    "title": "从数据库添加",
    "pick": "选择",
    "alreadyOnShortlist": "已在此候选名单中",
    "noResults": "没有匹配的资源。",
    "add": "添加到候选名单",
    "added_other": "已将 {{count}} 人添加到候选名单",
    "addFailed": "无法添加到候选名单。",
    "available": "{{start}} – {{end}} 有空",
    "availableValue": "有空",
    "availableSubject": "在候选名单日期内",
    "onlyWorkspace": "仅 {{name}}",
    "allWorkspaces": "所有工作区",
    "willJoin_other": "{{count}} 人将加入 {{name}}",
    "back": "返回",
    "joinAndAdd": "加入并添加",
    "notOnShortlist": "不在此候选名单中"
  },
  "ShortlistBoardToolbar": {
    "onlyForMe": "仅我可见",
    "sortBy": "排序：{{field}}",
    "sort": {
      "order": "自定义顺序",
      "votes": "最多投票",
      "name": "名称",
      "added": "最近添加"
    },
    "sizes": {
      "LARGE": "大",
      "MEDIUM": "中",
      "SMALL": "小"
    },
    "everyoneSees": "候选名单 · 所有人可见",
    "cardFields": "卡片字段",
    "cardSize": "卡片大小",
    "clientDefaultFilter": "客户默认筛选",
    "availability": "可用性",
    "addResources": "添加资源"
  },
  "ShortlistBoardTags": {
    "title": "团队标签"
  },
  "ShortlistBoardHero": {
    "title": "客户看到的标题",
    "titlePlaceholder": "添加标题",
    "description": "客户看到的描述",
    "descriptionPlaceholder": "添加描述"
  },
  "ShortlistVersionSwitch": {
    "title": "候选名单",
    "newVersionDescription": "你正在试用新版候选名单。它仍处于实验阶段——如有问题，可切换回经典版。你的候选名单不会改变。",
    "oldVersionDescription": "你正在使用经典版候选名单。新版处于测试阶段——随时可以试用。"
  },
  "VoteButtons": {
    "voteUp": "赞成",
    "voteDown": "反对",
    "voteFailed": "无法保存你的投票，请重试。",
    "upvotes_other": "{{count}} 票赞成",
    "downvotes_other": "{{count}} 票反对",
    "comments_other": "{{count}} 条评论",
    "openComments": "评论"
  },
  "ShortlistClientHeader": {
    "people_other": "{{count}} 人",
    "updated": "更新于 {{when}}",
    "showMore": "展开",
    "showLess": "收起",
    "tags": "标签"
  },
  "ShortlistBoardBody": {
    "empty": "此候选名单中还没有人。",
    "people": "候选名单中的人员",
    "unnamed": "未命名资源",
    "loading": "加载中…",
    "loadingPeople": "正在加载人员",
    "loadFailed": "无法加载候选名单。",
    "rowFailed": "无法加载此人。",
    "saveFailed": "无法保存更改，请重试。",
    "pick": "选择",
    "drag": "拖动以移动",
    "editGallery": "编辑图库",
    "noMatches": "此候选名单中没有匹配的人员。"
  },
  "ShortlistSelector": {
    "updated": "更新于 {{when}}",
    "untitled": "未命名候选名单"
  },
  "PublicShortlistPasswordGate": {
    "private": "私密候选名单",
    "label": "密码",
    "showPassword": "显示密码",
    "required": "请输入密码",
    "wrong": "该密码无法打开候选名单，请重试。",
    "failed": "无法验证密码。请检查网络连接后重试。",
    "submit": "打开候选名单",
    "help": "没有密码？请向发送链接给您的人索取。"
  },
  "ShortlistClientBoard": {
    "unpublishedTitle": "未发布",
    "unpublishedMessage": "打开链接的客户会看到此候选名单不可用。"
  },
  "PublicShortlistLoadFailed": {
    "title": "无法打开候选名单",
    "message": "请检查网络连接后重试。"
  },
  "PublicShortlistUnavailable": {
    "title": "此候选名单不可用",
    "message": "它可能已取消发布，或链接已更改。请向分享者索取新链接。"
  },
  "ViewingAs": {
    "label": "当前身份",
    "labelGuest": "当前身份：访客",
    "guest": "访客",
    "addName": "添加您的姓名",
    "changeName": "更改姓名"
  },
  "ClientVoteProgress": {
    "voted": "已投票 {{voted}}/{{total}}"
  },
  "AtellioFooter": {
    "madeWith": "此候选名单由 Atellio 制作——面向制作团队的人才平台。",
    "learnMore": "了解更多"
  },
  "ShortlistSearchFilters": {
    "search": "搜索此候选名单"
  },
  "GuestNameDialog": {
    "title": "您的姓名",
    "description": "在投票或评论之前，请告诉候选名单的所有者您是谁。",
    "label": "您的姓名",
    "placeholder": "名字和姓氏",
    "required": "请输入您的姓名",
    "save": "保存姓名"
  },
  "QrField": {
    "label": "二维码",
    "setUp": "设置二维码",
    "notSetUp": "尚未选择二维码的内容。",
    "cannotBuild": "无法生成二维码",
    "openSettings": "团队设置",
    "missing_other": "缺少 {{count}} 个字段",
    "missingHint": "此人员类型必填但为空：{{slots}}",
    "slots": {
      "gender": "性别",
      "bust": "胸围",
      "waist": "腰围",
      "height": "身高",
      "shoe": "鞋码",
      "bra_size": "文胸尺码"
    },
    "copyValue": "复制内容",
    "copied": "已复制",
    "downloadSvg": "下载 SVG",
    "hoverHint": "将鼠标悬停在二维码上可查看扫描器读取的内容；点击二维码可隐藏或显示标志。",
    "cannotBuildHint": "{{slots}}：映射的字段已从团队自定义字段中删除。",
    "hideLogo": "隐藏标志",
    "showLogo": "显示标志"
  },
  "ShortlistPdf": {
    "people_other": "{{count}} 人",
    "printedOn": "打印于 {{date}}",
    "page": "第 {{number}} 页，共 {{total}} 页",
    "votes": "{{up}} 赞成 · {{down}} 反对",
    "up": "{{count}} 赞成",
    "down": "{{count}} 反对",
    "sheetTitle": "人员资料页",
    "scanTitle": "拍摄用二维码",
    "scanHint": "打印后放入取景框。照片因此带有此人的姓名、分组、尺寸和资源编号，入库时会连同其参数一起保存。",
    "failed": "无法生成 PDF，请重试。",
    "menu": {
      "download": "下载 PDF…",
      "person": "下载人员资料页",
      "actions": "{{name}} 的操作",
      "button": "下载 PDF"
    },
    "dialog": {
      "title": "下载 PDF",
      "description": "选择要放入文件的内容。",
      "scope": {
        "label": "包含哪些人",
        "all": "候选名单中的所有人",
        "filtered": "按页面当前筛选",
        "selected": "已选中的人员"
      },
      "layout": {
        "label": "版式",
        "grid": "网格",
        "gridHint": "每页八人",
        "person": "人员资料页",
        "personHint": "每页一人，配大图",
        "slate": "二维码板",
        "slateHint": "为每个人生成大尺寸二维码，放入取景框"
      },
      "paper": {
        "label": "纸张",
        "a4": "A4",
        "letter": "Letter"
      },
      "qr": {
        "label": "二维码",
        "description": "打印每个人的二维码"
      },
      "summary_other": "文件中共 {{count}} 人",
      "loading": "正在加载人员…",
      "loadFailed": "无法加载人员。",
      "empty": "没有可放入文件的人员。",
      "submit": "下载",
      "pictures": "正在获取图片 {{completed}} / {{total}}",
      "drawing": "正在绘制页面…",
      "slates": {
        "label": "每页数量",
        "one": "每页一张",
        "four": "每页四张，带裁剪线"
      },
      "summarySlates_other": "文件中共 {{count}} 张二维码板",
      "skipped_other": "{{count}} 人没有二维码值，不会生成二维码板",
      "noSlates": "这里没有人有二维码值。"
    },
    "madeWith": "使用",
    "slateCut": "沿虚线裁剪"
  }
}
